export function navigationBottom(): number {
  return document.querySelector('header.sticky')?.getBoundingClientRect().bottom ?? 0;
}

export function anchoredPosition(rect: DOMRect, width: number, height: number, gap = 12) {
  const margin = 16;
  const minTop = Math.max(margin, navigationBottom() + gap);
  const below = Math.max(0, innerHeight - margin - Math.max(minTop, rect.bottom + gap));
  const above = Math.max(0, rect.top - gap - minTop);
  const useBelow = below >= height || below >= above;
  const maxH = Math.min(720, useBelow ? below : above);
  return {
    left: Math.max(margin, Math.min(rect.left, innerWidth - width - margin)),
    top: useBelow ? Math.max(minTop, rect.bottom + gap) : Math.max(minTop, rect.top - gap - Math.min(height, maxH)),
    maxH,
  };
}
